import { IOrder } from '@/store/ducks/order/types';

function isJsonString(str: string): boolean {
  try {
    const parsed = JSON.parse(str);
    return typeof parsed === 'object' && parsed !== null;
  } catch (e) {
    return false;
  }
}

export const useLocalOrder: () => string | false | IOrder = () => {
  const localOrder = localStorage.getItem('order');

  if (!localOrder) return false;

  if (isJsonString(localOrder)) {
    try {
      return JSON.parse(localOrder) as IOrder;
    } catch (e) {
      return false;
    }
  }

  return localOrder;
};
